<div class="row">
  <div *ngIf="errorText" class="col-12 error-text">
    Your session has expired. <br> Please log in or dismiss to return home.
  </div>
</div>
<app-login-form
  [modalPadding]="true"
  (loginSuccessEvent)="onLoginSuccess()"
></app-login-form>
